<template>

  <div class="center-form background-gradient">
    <div class="card" v-if="reg_end">
      <div class="card-body text-center">
        <h4 class="card-text mb-3">
          Подтверждение активации прошло успешно
        </h4>
        <small>
          Вы будете автоматически перенаправлены на вход через
          <strong>{{ currentTime }}</strong>
        </small>
      </div>

    </div>
    <template v-else>
      <form class="card" @submit.prevent="change_password" v-if="!errors.length">
        <div class="logo">
          <svg viewBox="0 0 24 24">
            <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
                fill="#667eea"/>
          </svg>
        </div>
        <h1>Активация аккаунта</h1>
        <p class="subtitle">Создайте пароль для входа в систему</p>

        <div class="email-display"><i class="bi bi-envelope-fill"></i>
          <span id="userEmail">{{ user.email }}</span>
        </div>

        <div class="password-container">
          <label>Придумайте пароль</label>
          <div class="form-floating password-input mt-2">
            <input class="form-control" id="password" :type="show_pass?'text':'password'" name="password" required
                   v-model="user.password" placeholder="Пароль">
            <i v-on:click="show_pass=!show_pass" :class="`bi text-dark bi-eye${show_pass?' active':''}`"></i>
            <label>Пароль</label>
          </div>
          <div class="password-strength">
            <div class="strength-bar" :style="{width: strengthBar.width+'%', backgroundColor: strengthBar.color}"
                 id="strengthBar"></div>
          </div>
          <div class="strength-text" :style="{color: strengthBar.color}" id="strengthText">{{ strengthBar.text }}</div>
          <label>Повторите пароль</label>
          <div class="form-floating password-input mt-2">
            <input class="form-control" id="password" :type="show_pass?'text':'password'" name="password" required
                   v-model="user.password_repeat" placeholder="Пароль">
            <i v-on:click="show_pass=!show_pass" :class="`bi text-dark bi-eye${show_pass?' active':''}`"></i>
            <label>Пароль</label>
          </div>


        </div>

        <!--            <div class="password-requirements">-->
        <!--              <div v-for="(rule, key) in rules" :class="'requirement' + (rule.valid?' valid':'')" :id="key">-->
        <!--                <svg viewBox="0 0 24 24">-->
        <!--                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>-->
        <!--                </svg>-->
        <!--                {{ rule.name }}-->
        <!--              </div>-->

        <!--            </div>-->

        <div v-if="error" class="error-message" id="errorMessage">
          {{ error }}
        </div>


        <button type="submit" class="mt-2">Активировать аккаунт</button>

        <div class="expiry-note">
          <svg viewBox="0 0 24 24">
            <path
                d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/>
          </svg>
          Ссылка действительна 24 часа
        </div>
      </form>
      <div class="card error" v-else>
        <p v-for="error in errors">{{ error }}</p>
      </div>
    </template>
  </div>

</template>
<script>

import {UserApi} from "@/api/user";
import user from "@/store/user";

export default {
  name: 'ProjectPermActivate',
  data() {
    return {
      show_pass: false,
      currentTime: 5,
      timer: null,
      errors: ["Недействительный пользователь"],
      error: null,
      strengthBar: {color: "", width: 0, text: "Надёжность пароля"},
      reg_end: false,
      user: {email: "user@example.com", password: "", password_repeat: ""},
      rules: {
        hasLength: {name: "Минимум 8 символов", valid: false},
        hasNumber: {name: "Хотя бы одна цифра", valid: false},
        hasLetter: {name: "Заглавная и строчная буквы", valid: false},
      }
    }
  },
  computed: {},
  watch: {
    "user.password"(password) {

      const hasLength = password.length >= 8;
      const hasNumber = /\d/.test(password);
      const hasUpper = /[A-Z]/.test(password);
      const hasLower = /[a-z]/.test(password);
      const hasLetter = hasUpper && hasLower;

      this.rules.hasLength.valid = hasLength;
      this.rules.hasNumber.valid = hasNumber;
      this.rules.hasLetter.valid = hasLetter;

      let strength = 0;
      if (hasLength) strength += 25;
      if (hasNumber) strength += 25;
      if (hasUpper) strength += 25;
      if (hasLower) strength += 25;

      this.strengthBar.width = strength;

      if (strength < 50) {
        this.strengthBar.color = '#dc3545';
        this.strengthBar.text = 'Слабый пароль';
      } else if (strength < 75) {
        this.strengthBar.color = '#ffc107';
        this.strengthBar.text = 'Средний пароль';
      } else {
        this.strengthBar.color = '#28a745';
        this.strengthBar.text = 'Надёжный пароль';
      }

    },
     currentTime(time) {
      if (time === 0) {
        this.stopTimer();
        this.$router.push({name: "login"});
      }
    }
  },
  mounted() {
    UserApi.check_token(this.$route.params.uuid,
        this.$route.params.token).then(response => {
      this.user.email = response.data.email;
      this.errors = response.data.errors || [];
    })
  },
  destroyed() {
    this.stopTimer()
  },
  methods: {
    change_password: function (e) {
      e.preventDefault();
      if (this.user.password !== this.user.password_repeat) {
        this.$notify({
          type: 'error',
          text: "Введёённые пароли не совпадают"
        });
      } else {
        UserApi.check_activate(this.$route.params.code).then(() => {
          UserApi.change_password({
            uid: this.$route.params.uuid,
            token: this.$route.params.token,
            password: this.user.password,
            tariff: 1
          }).then(() => {
            this.reg_end = true
            this.startTimer()
          })
        })

      }
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.currentTime--
      }, 1000)
    },
    stopTimer() {
      clearTimeout(this.timer)
    },
  }
}
</script>
<style scoped lang="scss">
.center-form {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 20px;
  align-items: baseline;

  .card {
    margin: 0 auto;
    background: var(--deep-blue);
    padding: 20px;
    border-radius: 10px;
    max-width: 360px;
    box-shadow: var(--box-shadow);
    text-align: center;
    color: var(--white);
    min-width: 380px;

    &.error {
      background: rgb(224, 65, 65, 0.8);
      font-size: 20px;
    }

    .logo {
      svg {
        width: 60px;
        height: 60px;
      }
    }

    h1 {
      font-size: 24px;
      margin-bottom: 15px;
      font-weight: 600;
    }

    .subtitle {
      font-size: 16px;
      line-height: 1.5;
      margin-bottom: 30px;
    }

    .email-display {
      background: #f7f9fc;
      border-radius: 12px;
      padding: 15px;
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      font-size: 16px;
      color: #333;
      border: 1px solid #e1e4e8;

      i {
        display: block;
        width: 20px;
        height: 20px;
        fill: #667eea;
      }
    }

    .forget {
      display: flex;
      justify-content: space-around;
    }
  }

}

.password-container {
  text-align: left;
}

label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
}

.password-input-wrapper {
  position: relative;
}

input[type="password"],
input[type="text"] {
  width: 100%;
  padding: 15px;
  border: 2px solid #e1e4e8;
  border-radius: 12px;
  font-size: 16px;
  transition: border-color 0.3s;
  background: white;
}

input[type="password"]:focus,
input[type="text"]:focus {
  outline: none;
  border-color: #667eea;
}

.toggle-password {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #999;
  font-size: 14px;
  user-select: none;
}

.password-strength {
  margin-top: 8px;
  height: 4px;
  background: #e1e4e8;
  border-radius: 2px;
  overflow: hidden;
}

.strength-bar {
  height: 100%;
  width: 0;
  transition: width 0.3s, background-color 0.3s;
}

.strength-text {
  font-size: 12px;
  margin-top: 5px;
  color: #999;
}

.password-requirements {
  text-align: left;
  margin: 10px 0;
  padding: 15px;
  background: #f7f9fc;
  border-radius: 12px;
  border: 1px solid #e1e4e8;
}

.requirement {
  color: #666;
  font-size: 13px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.requirement:last-child {
  margin-bottom: 0;
}

.requirement.valid {
  color: #28a745;
}

.requirement svg {
  width: 16px;
  height: 16px;
  fill: currentColor;
}

button {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.expiry-note {
  margin-top: 20px;
  color: #999;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.expiry-note svg {
  width: 16px;
  height: 16px;
  fill: #999;
}

.error-message {
  color: #dc3545;
  font-size: 14px;
  margin: 10px 0;
  display: none;
}

.success-message {
  display: none;
  color: #28a745;
  font-size: 16px;
  margin: 20px 0;
  padding: 15px;
  background: #d4edda;
  border-radius: 12px;
  border: 1px solid #c3e6cb;
}

.footer {
  margin-top: 20px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  text-align: center;
}
</style>
